import { Card, CardContent, CardMedia } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';

export const ImageCardComponent = ({
  children,
  image,
  alt,
  color,
  isVisible = true,
  ...props
}) => {
  return (
    <>
      {isVisible && (
        <Card
          sx={{
            display: 'flex',
            bgcolor: color,
            width: '340px',
            height: '160px',
            borderRadius: '8px',
          }}
          {...props}>
          <CardMedia
            component="img"
            sx={{
              width: '100%',
              height: '100%',
              maxWidth: '120px',
              maxHeight: '120px',
              marginLeft: '-10px',
              objectFit: 'contain',
              alignSelf: 'flex-end',
            }}
            image={image}
            alt={alt}
          />

          <CardContent sx={{ display: 'flex', flexDirection: 'column' }}>
            {children}
          </CardContent>
        </Card>
      )}
    </>
  );
};

ImageCardComponent.propTypes = {
  image: PropTypes.string,
  alt: PropTypes.string,
  color: PropTypes.string,
  isVisible: PropTypes.bool,
  children: PropTypes.node,
};
